import { IPropertyInfoMetadata } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework/Reflection/IPropertyInfoMetadata";
import { ITypeInfoMetadata } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework/Reflection/ITypeInfoMetadata";
import { EntityBaseProperties, IEntityBaseProperties } from "@seriously-rad/seriouslyrad-framework-core/Server/Schema/Entities/BaseTypes/EntityBaseProperties";
import { ISoftDeletableEntityProperties, SoftDeletableEntityProperties } from "@seriously-rad/seriouslyrad-framework-core/Server/Schema/Entities/BaseTypes/SoftDeletableEntityProperties";

export interface IMediatorEvaluationFormProperties extends IEntityBaseProperties, ISoftDeletableEntityProperties
{

    // #region Basic Properties

    caseId: IPropertyInfoMetadata;
    mediationDate: IPropertyInfoMetadata;
    confirmationDocumentsReceivedLookupItemId: IPropertyInfoMetadata;
    confirmationDocumentsLateReason: IPropertyInfoMetadata;
    errorsInReferralSummaryOrNoticeOfArrangementsLookupItemId: IPropertyInfoMetadata;
    errorsInReferralSummaryOrNoticeOfArrangementsComments: IPropertyInfoMetadata;
    administrativeSupportComments: IPropertyInfoMetadata;
    heathAndSocialCare: IPropertyInfoMetadata;
    caseTypeLookupItemId: IPropertyInfoMetadata;
    ehcpSectionsInDispute: IPropertyInfoMetadata;
    preMediationWorkLengthLookupItemId: IPropertyInfoMetadata;
    preMediationWorkLengthComments: IPropertyInfoMetadata;
    mediationMeetingLengthLookupItemId: IPropertyInfoMetadata;
    mediationMeetingLengthComments: IPropertyInfoMetadata;
    meetingAttendees: IPropertyInfoMetadata;
    howViewsOfCypMadeKnownLookupItemId: IPropertyInfoMetadata;
    whyCypDidNotAttendReasonLookupItemId: IPropertyInfoMetadata;
    whyCypDidNotAttendReasonOther: IPropertyInfoMetadata;
    attendeesProvidedCsqFormLookupItemId: IPropertyInfoMetadata;
    csqNotProvidedReason: IPropertyInfoMetadata;
    mediationOutcomeLookupItemId: IPropertyInfoMetadata;
    mediationOutcomeOther: IPropertyInfoMetadata;

    // #endregion

    // #region Navigation Properties

    case: IPropertyInfoMetadata;
    attendeesProvidedCsqFormLookupItem: IPropertyInfoMetadata;
    caseTypeLookupItem: IPropertyInfoMetadata;
    confirmationDocumentsReceivedLookupItem: IPropertyInfoMetadata;
    howViewsOfCypMadeKnownLookupItem: IPropertyInfoMetadata;
    mediationMeetingLengthLookupItem: IPropertyInfoMetadata;
    mediationOutcomeLookupItem: IPropertyInfoMetadata;
    preMediationWorkLengthLookupItem: IPropertyInfoMetadata;
    whyCypDidNotAttendReasonLookupItem: IPropertyInfoMetadata;

    // #endregion

}

export const MediatorEvaluationForm: ITypeInfoMetadata<IMediatorEvaluationFormProperties> = {
    attributes: [
        {
            id: "{AD505944-189A-4476-B07F-AE13FA53974D}",
            $type: "SeriouslyRAD.Framework.ClientAwareIdAttribute, SeriouslyRAD.Framework"
        },
        {
            name: "MediatorEvaluationForm",
            nameFriendly: "Mediator Evaluation Form",
            namePlural: "MediatorEvaluationForms",
            namePluralFriendly: "Mediator Evaluation Forms",
            $type: "SeriouslyRAD.Framework.ClientAwareNameAttribute, SeriouslyRAD.Framework"
        }
    ],
    classHierarchy: [
        "GlobalMediation.Data.Entities.MediatorEvaluationForm, GlobalMediation.Data.Entities",
        "SeriouslyRAD.Framework.Data.EntityBase, SeriouslyRAD.Framework.Data.Entities",
        "System.Object, System.Private.CoreLib"
    ],
    hasEnumFlags: false,
    name: "MediatorEvaluationForm",
    properties: {
        ...EntityBaseProperties,
        ...SoftDeletableEntityProperties,
        caseId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Case"
                },
                {
                    entityDescriptionProperty: "ListDescription",
                    entityName: "Case",
                    entityNameFriendly: "Case",
                    entityNamePlural: "Cases",
                    entityNamePluralFriendly: "Cases",
                    foreignEntityAlias: "MediatorEvaluationForms",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareEntityIdAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.MediatorEvaluationForm+CaseIdMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 0
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CaseId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediationDate: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Mediation Date"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.MediatorEvaluationForm+MediationDateMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 1
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MediationDate",
            propertyTypeId: "System.Nullable`1[[System.DateOnly, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        confirmationDocumentsReceivedLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Confirmation Documents Received?"
                },
                {
                    helpText: "Please select when you received the meeting confirmation documents.",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    foreignEntityAlias: "MediatorEvaluationFormsByConfirmationDocumentsReceived",
                    typeDescription: "MEF Confirmation Documents Received",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.MediatorEvaluationForm+ConfirmationDocumentsReceivedLookupItemIdMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 2
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "ConfirmationDocumentsReceivedLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        confirmationDocumentsLateReason: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Confirmation Documents Late"
                },
                {
                    helpText: "Please provide an explanation as to why the confirmation documents were received within less than two days of the meeting",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.MediatorEvaluationForm+ConfirmationDocumentsLateReasonMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    blankIfNotRelevant: true,
                    evaluator: {
                        propertyName: "ConfirmationDocumentsReceivedLookupItemId",
                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                        propertyValue: "5c7ccdfe-c2b9-461f-9be3-891fd5ec2d9a",
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareRelevantEvaluatorAttribute`1[[GlobalMediation.Data.Entities.MediatorEvaluationForm+ConfirmationDocumentsLateReasonRelevantEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 3
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "ConfirmationDocumentsLateReason",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        errorsInReferralSummaryOrNoticeOfArrangementsLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Errors in Referral Summary or Notice of Arrangements?"
                },
                {
                    helpText: "Please select areas for any errors contained in the Referral Summary/Notice of Arrangements (select all that apply).",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 4
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "ErrorsInReferralSummaryOrNoticeOfArrangementsLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Int32, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        errorsInReferralSummaryOrNoticeOfArrangementsComments: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Further Comment"
                },
                {
                    helpText: "An option to comment on selected Errors of Referral Summary / Notice of Arrangements",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    blankIfNotRelevant: true,
                    evaluator: {
                        propertyName: "ErrorsInReferralSummaryOrNoticeOfArrangementsLookupItemId",
                        comparerId: "b1077685-1c05-4865-b95d-cf7542071813",
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Object, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareRelevantEvaluatorAttribute`1[[GlobalMediation.Data.Entities.MediatorEvaluationForm+ErrorsInReferralSummaryOrNoticeOfArrangementsCommentsRelevantEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 5
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "ErrorsInReferralSummaryOrNoticeOfArrangementsComments",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        administrativeSupportComments: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Administrative Support Comments"
                },
                {
                    helpText: "Do you have any comments on the administrative support that we need to know about?",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 6
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "AdministrativeSupportComments",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        heathAndSocialCare: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Health and Social Care"
                },
                {
                    helpText: "Please select if any of the following attendees formed a significant part of the mediation discussion (select all that apply).",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.MediatorEvaluationForm+HeathAndSocialCareMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 7
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "HeathAndSocialCare",
            propertyTypeId: "System.Nullable`1[[System.Int32, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        caseTypeLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Type of Case"
                },
                {
                    helpText: "Please confirm the type of case.",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    foreignEntityAlias: "MediatorEvaluationFormsByCaseType",
                    typeDescription: "MEF Case Types",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.MediatorEvaluationForm+CaseTypeLookupItemIdMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 8
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CaseTypeLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        ehcpSectionsInDispute: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "EHCP Sections In Dispute"
                },
                {
                    helpText: "Please specify EHCP sections in dispute (select all that apply).",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.MediatorEvaluationForm+EhcpSectionsInDisputeMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    blankIfNotRelevant: true,
                    evaluator: {
                        propertyName: "CaseTypeLookupItemId",
                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                        propertyValue: "7501e624-dca3-460d-8b89-1b19d3adfcbb",
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareRelevantEvaluatorAttribute`1[[GlobalMediation.Data.Entities.MediatorEvaluationForm+EhcpSectionsInDisputeRelevantEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 9
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "EhcpSectionsInDispute",
            propertyTypeId: "System.Nullable`1[[System.Int32, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        preMediationWorkLengthLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Length of Pre-Mediation Work"
                },
                {
                    helpText: "Please select the length of time taken for all the pre-mediation work.",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    foreignEntityAlias: "MediatorEvaluationFormsByPreMediationWorkLength",
                    typeDescription: "MEF Pre-Mediation Work Lengths",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.MediatorEvaluationForm+PreMediationWorkLengthLookupItemIdMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 10
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "PreMediationWorkLengthLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        preMediationWorkLengthComments: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Pre-Mediation Work Length Comments"
                },
                {
                    helpText: "Please provide details",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.MediatorEvaluationForm+PreMediationWorkLengthCommentsMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    blankIfNotRelevant: true,
                    evaluator: {
                        evaluators: [
                            {
                                propertyName: "PreMediationWorkLengthLookupItemId",
                                comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                                propertyValue: "54cf4a11-6b83-4b9b-b97f-e8e8e9300fef",
                                $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                            },
                            {
                                propertyName: "PreMediationWorkLengthLookupItemId",
                                comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                                propertyValue: "6a19a532-6859-4151-98ac-8c7939e7e327",
                                $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                            }
                        ],
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.OrEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareRelevantEvaluatorAttribute`1[[GlobalMediation.Data.Entities.MediatorEvaluationForm+PreMediationWorkLengthCommentsRelevantEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 11
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "PreMediationWorkLengthComments",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediationMeetingLengthLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Mediation Meeting Length"
                },
                {
                    helpText: "Please select the length of the mediation/DR meeting, from the point of greeting the parties up to the point of closing the meeting.",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    foreignEntityAlias: "MediatorEvaluationFormsByMediationMeetingLength",
                    typeDescription: "MEF Mediation Meeting Lengths",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.MediatorEvaluationForm+MediationMeetingLengthLookupItemIdMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 12
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MediationMeetingLengthLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediationMeetingLengthComments: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Mediation Meeting Length Comments"
                },
                {
                    helpText: "Please provide details",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.MediatorEvaluationForm+MediationMeetingLengthCommentsMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    blankIfNotRelevant: true,
                    evaluator: {
                        propertyName: "MediationMeetingLengthLookupItemId",
                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                        propertyValue: "a082b999-f452-4bf1-9399-101c4ab33099",
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareRelevantEvaluatorAttribute`1[[GlobalMediation.Data.Entities.MediatorEvaluationForm+MediationMeetingLengthCommentsRelevantEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 13
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MediationMeetingLengthComments",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        meetingAttendees: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Meeting Attendees"
                },
                {
                    helpText: "Please select all meeting attendees (select all that apply).",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.MediatorEvaluationForm+MeetingAttendeesMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 14
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MeetingAttendees",
            propertyTypeId: "System.Nullable`1[[System.Int32, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        howViewsOfCypMadeKnownLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "How Views of CYP Made Known"
                },
                {
                    helpText: "Please identify the primary method used to ensure that the views of the child / young person were made known during the meeting.",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    foreignEntityAlias: "MediatorEvaluationFormsByHowViewsOfCypMadeKnown",
                    typeDescription: "MEF How Views of CYP Made Known",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.MediatorEvaluationForm+HowViewsOfCypMadeKnownLookupItemIdMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    blankIfNotRelevant: true,
                    evaluator: {
                        evaluator: {
                            propertyName: "MeetingAttendees",
                            propertyValue: 64,
                            $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.EnumFlagEvaluator, SeriouslyRAD.Framework.Data.Entities"
                        },
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.NotEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareRelevantEvaluatorAttribute`1[[GlobalMediation.Data.Entities.MediatorEvaluationForm+HowViewsOfCypMadeKnownLookupItemIdRelevantEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 15
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "HowViewsOfCypMadeKnownLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        whyCypDidNotAttendReasonLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Why CYP Did Not Attend"
                },
                {
                    helpText: "Where the CYP did not attend, please identify the main reason why.",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    foreignEntityAlias: "MediatorEvaluationFormsByWhyCypDidNotAttendReason",
                    typeDescription: "MEF Why CYP Did Not Attend Reasons",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.MediatorEvaluationForm+WhyCypDidNotAttendReasonLookupItemIdMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    blankIfNotRelevant: true,
                    evaluator: {
                        evaluator: {
                            propertyName: "MeetingAttendees",
                            propertyValue: 64,
                            $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.EnumFlagEvaluator, SeriouslyRAD.Framework.Data.Entities"
                        },
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.NotEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareRelevantEvaluatorAttribute`1[[GlobalMediation.Data.Entities.MediatorEvaluationForm+WhyCypDidNotAttendReasonLookupItemIdRelevantEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 16
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "WhyCypDidNotAttendReasonLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        whyCypDidNotAttendReasonOther: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                    description: "Please provide details"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Why CYP Did Not Attend (Other)"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.MediatorEvaluationForm+WhyCypDidNotAttendReasonOtherMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    blankIfNotRelevant: true,
                    evaluator: {
                        evaluators: [
                            {
                                propertyName: "WhyCypDidNotAttendReasonLookupItemId",
                                comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                                propertyValue: "4cd43fc8-8487-4496-8024-98ad7f0b7354",
                                $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                            },
                            {
                                evaluator: {
                                    propertyName: "MeetingAttendees",
                                    propertyValue: 64,
                                    $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.EnumFlagEvaluator, SeriouslyRAD.Framework.Data.Entities"
                                },
                                $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.NotEvaluator, SeriouslyRAD.Framework.Data.Entities"
                            }
                        ],
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.AndEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareRelevantEvaluatorAttribute`1[[GlobalMediation.Data.Entities.MediatorEvaluationForm+WhyCypDidNotAttendReasonOtherRelevantEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 17
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "WhyCypDidNotAttendReasonOther",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        attendeesProvidedCsqFormLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Were Attendees Provided with a CSQ Form?"
                },
                {
                    helpText: "Please confirm that attendees were provided with the CSQ form.",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    foreignEntityAlias: "MediatorEvaluationFormsByAttendeesProvidedCsqForm",
                    typeDescription: "MEF Attendees Provided CSQ Form",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.MediatorEvaluationForm+AttendeesProvidedCsqFormLookupItemIdMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 18
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "AttendeesProvidedCsqFormLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        csqNotProvidedReason: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Reason CSQ Not Provided"
                },
                {
                    helpText: "Please explain reason below.",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.MediatorEvaluationForm+CsqNotProvidedReasonMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    blankIfNotRelevant: true,
                    evaluator: {
                        propertyName: "AttendeesProvidedCsqFormLookupItemId",
                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                        propertyValue: "40c4b58d-218d-49a6-8a07-f716a40c14eb",
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareRelevantEvaluatorAttribute`1[[GlobalMediation.Data.Entities.MediatorEvaluationForm+CsqNotProvidedReasonRelevantEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 19
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CsqNotProvidedReason",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediationOutcomeLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Mediation Outcome"
                },
                {
                    helpText: "What was the outcome of mediation?",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    foreignEntityAlias: "MediatorEvaluationFormsByMediationOutcome",
                    typeDescription: "MEF Mediation Outcomes",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.MediatorEvaluationForm+MediationOutcomeLookupItemIdMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 20
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MediationOutcomeLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediationOutcomeOther: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Mediation Outcome (Other)"
                },
                {
                    helpText: "Please specify reason.",
                    $type: "SeriouslyRAD.Framework.ClientAwareHelpTextAttribute, SeriouslyRAD.Framework"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.MediatorEvaluationForm+MediationOutcomeOtherMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    blankIfNotRelevant: true,
                    evaluator: {
                        propertyName: "MediationOutcomeLookupItemId",
                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                        propertyValue: "3f69cd30-b2a2-4be8-b761-16aa7423ea24",
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareRelevantEvaluatorAttribute`1[[GlobalMediation.Data.Entities.MediatorEvaluationForm+MediationOutcomeOtherRelevantEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 21
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MediationOutcomeOther",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        attendeesProvidedCsqFormLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "AttendeesProvidedCsqFormLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        case: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "Case",
            propertyTypeId: "GlobalMediation.Data.Entities.Case, GlobalMediation.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        caseTypeLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CaseTypeLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        confirmationDocumentsReceivedLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "ConfirmationDocumentsReceivedLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        howViewsOfCypMadeKnownLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "HowViewsOfCypMadeKnownLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediationMeetingLengthLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MediationMeetingLengthLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediationOutcomeLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MediationOutcomeLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        preMediationWorkLengthLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "PreMediationWorkLengthLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        whyCypDidNotAttendReasonLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "WhyCypDidNotAttendReasonLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        }
    },
    underlyingTypeId: "GlobalMediation.Data.Entities.MediatorEvaluationForm, GlobalMediation.Data.Entities",
    $type: "SeriouslyRAD.Framework.Reflection.TypeInfoMetadata, SeriouslyRAD.Framework"
};

